// @flow
import { httpDelete, httpGet, httpPost } from '~/core/api/helpers/helpers.api';

const endpoint = 'holiday-mode';

export function getHolidayMode(): Promise<Response> {
    return httpGet(endpoint);
}

export function setHolidayMode(start: string, end: string, temperature: string): Promise<Response> {
    return httpPost(endpoint, { start, end, temperature });
}

export function disableHolidayMode(): Promise<Response> {
    return httpDelete(endpoint);
}



// WEBPACK FOOTER //
// ./src/core/api/holiday-mode/index.js